import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { PortalShell } from "@/components/layout/PortalShell";
import { ADMIN_NAV } from "@/lib/admin-nav";
import { MessageInbox } from "@/components/messaging/MessageInbox";

export const Route = createFileRoute("/admin/messages")({
  head: () => ({
    meta: [
      { title: "Messages — Command Center" },
      { name: "description", content: "Read and reply to every client and strategist conversation." },
      { property: "og:title", content: "Messages — Command Center" },
      { property: "og:description", content: "Read and reply to every client and strategist conversation." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: () => (
    <ProtectedRoute requiredRole="admin">
      <PortalShell title="Command Center" nav={ADMIN_NAV}>
        <MessageInbox scope="admin" />
      </PortalShell>
    </ProtectedRoute>
  ),
});
